import React from 'react';
import { List, ListItem } from '@lux/list';
import { ChevronRightS } from '@lux/zds-icons';
import { FunctionColor } from '@lux/tokens';
import { TranslateScope } from '@pegasus/translation';
import { CategoryIcon } from '../categories';
import { Wrapper, ListSpacing } from './CrossCampaignCategoryEntryView.styles';
import { CrossCampaignCategoryList } from '../cross-campaign-category-list';
/**
 * CrossCampaignCategoryEntryView - Presentational component for cross-campaign category entry
 *
 * This is a pure presentational component that renders the UI for selecting categories
 * in a cross-campaign filter context. It displays a list of category elements and
 * conditionally shows a nested category list based on selection state.
 *
 * @example
 * ```tsx
 * <CrossCampaignCategoryEntryView
 *   tab={categoryTab}
 *   selectedLevelOneCategory={selectedCategory}
 *   preExpandedCategories={expandedCategories}
 *   allCategories={allCategories}
 *   selectableCategories={selectableCategories}
 *   selectedCategories={selectedCategories}
 *   onSelectCategory={handleSelectCategory}
 *   onResetSelectedCategories={handleReset}
 *   onHandleSelectedCategories={handleSelectedCategories}
 *   onResetPreExpandedCategories={resetPreExpanded}
 *   onSetSelectedCategory={setSelectedCategory}
 *   onRedirectToCatalog={handleRedirectToCatalog}
 *   isCompact={true}
 *   trackingContext={cross_campaign_filter}
 * />
 * ```
 */
export var CrossCampaignCategoryEntryView = function (_a) {
    var tab = _a.tab, selectedLevelOneCategory = _a.selectedLevelOneCategory, preExpandedCategories = _a.preExpandedCategories, allCategories = _a.allCategories, selectableCategories = _a.selectableCategories, selectedCategories = _a.selectedCategories, onSelectCategory = _a.onSelectCategory, onResetSelectedCategories = _a.onResetSelectedCategories, onHandleSelectedCategories = _a.onHandleSelectedCategories, onResetPreExpandedCategories = _a.onResetPreExpandedCategories, onSetSelectedCategory = _a.onSetSelectedCategory, _b = _a.wrapperTestId, wrapperTestId = _b === void 0 ? 'ccf-level-2-entrypoint-xs-screen' : _b, _c = _a.listItemTestId, listItemTestId = _c === void 0 ? 'ccf-level-2-entrypoint-filter-xs-screen' : _c, _d = _a.translationScope, translationScope = _d === void 0 ? 'catalog' : _d, onRedirectToCatalog = _a.onRedirectToCatalog, _e = _a.isCompact, isCompact = _e === void 0 ? false : _e, trackingContext = _a.trackingContext;
    if (!tab) {
        return null;
    }
    return (React.createElement(Wrapper, { "data-testid": wrapperTestId },
        React.createElement(TranslateScope, { path: translationScope },
            React.createElement(ListSpacing, { "$isCompact": isCompact },
                React.createElement(List, { role: "list" }, tab.elements.map(function (category) { return (React.createElement(ListItem, { actionRole: "button", "data-testid": listItemTestId, key: category.id, label: category.name, leftAction: React.createElement(CategoryIcon, { id: category.id }), onAction: function () { return onSelectCategory(category.id); }, rightAction: React.createElement(ChevronRightS, { color: FunctionColor.function60 }) })); }))),
            (selectedLevelOneCategory || !!preExpandedCategories.level1) && (React.createElement(CrossCampaignCategoryList, { allCategories: allCategories, selectableCategories: selectableCategories, selectedCategories: selectedCategories, resetSelectedCategories: onResetSelectedCategories, handleSelectedCategories: onHandleSelectedCategories, preExpandedCategories: preExpandedCategories, resetPreExpandedCategories: onResetPreExpandedCategories, setSelectedCategory: onSetSelectedCategory, onRedirectToCatalog: onRedirectToCatalog, translationScope: translationScope, trackingContext: trackingContext })))));
};
